import { FC } from 'react';
import { Modal } from 'antd';

interface IProps {
  id: string;
  isModalVisible: boolean;
  handleCancel: () => void;
  deletePaymentMethod: (id: string) => void;
}

const DeletePaymentMethod: FC<IProps> = (props) => {
  const { id, isModalVisible, handleCancel, deletePaymentMethod } = props;

  const handleOk = () => {
    deletePaymentMethod(id);
    handleCancel();
  }

  return (
    <Modal visible={isModalVisible} okText={"Delete"} okButtonProps={{
      danger: true,
    }} onOk={handleOk} onCancel={handleCancel}>
      <header>
        <h1>Warning!</h1>
      </header>
      <div className="center">
        <b>Delete Payment Method #{id}?</b>
        <br/>
        Note that this action cannot be undone.
      </div>
    </Modal>
  )
}

export default DeletePaymentMethod;